module.exports = __webpack_public_path__ + "6cc45cd4effe6f8235a74ac60b7b173e.jpg";